<template>
    <div class="flex items-center">
        <Input
            v-model:model-value="model"
            class="rounded-r-none"
            :min="min"
            :type="type"
        ></Input>
        <div
            class="flex max-h-10 items-center justify-center rounded-r-md border border-l-0 border-iron-300 bg-iron-25 px-3 py-2 text-iron-600"
        >
            <slot />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { Input } from ".";

defineProps<{
    min?: number;
    type?: string;
}>();

const model = defineModel<string | number>();
</script>
